'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VisibilityIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

var _constantsList = require('@bibliocommons/constants-list');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VisibilityIcon(_ref) {
  var visibility = _ref.visibility;

  if (visibility === _constantsList.VISIBILITY.NOT_VISIBLE) {
    return _react2.default.createElement(_baseIcons.Lock, { className: 'cp-visibility-icon' });
  } else if (visibility === _constantsList.VISIBILITY.GEOFENCED) {
    return _react2.default.createElement(_baseIcons.Bullseye, { className: 'cp-visibility-icon' });
  } else if (visibility === _constantsList.VISIBILITY.LINK) {
    return _react2.default.createElement(_baseIcons.Link, { className: 'cp-visibility-icon' });
  }

  return _react2.default.createElement(_baseIcons.Unlock, { className: 'cp-visibility-icon' });
}

VisibilityIcon.propTypes = {
  visibility: _react.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-icon/components/VisibilityIcon.component.js
// module id = 1349
// module chunks = 0